// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@media all and (max-width: 500px) {\n.well {\n    padding: 19px 8px;\n}\n.upload-success-btns {\n    width: 100%;\n    margin-bottom: 10px;\n}\n.upload-success-btns .btn {\n    padding: 7px 5px;\n    font-size: 12px;\n}\n}\n", ""]);
// Exports
module.exports = exports;
